import { DOCUMENT } from "@angular/common";
import { Component, Input, inject } from "@angular/core";

@Component({
  selector: "ngx-update-notice",
  templateUrl: "./update-notice.component.html",
  standalone: false,
})
export class UpdateNoticeComponent {
  private readonly document = inject(DOCUMENT);

  @Input() show: boolean;

  refresh() {
    this.show = false;
    this.document.location.reload();
  }
}
